import { AuditNote } from '@cdab/scania/qpr/components/atoms'
import { auditsController } from '@cdab/scania/qpr/offline/controllers'
import type { AuditModel } from '@cdab/scania/qpr/offline/models'
import { capitalizeFirstLetter } from '@cdab/utils'
import { TdsBlock, TdsButton } from '@scania/tegel-react'
import { observer } from 'mobx-react-lite'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type AuditInfoProps = {
  audit: AuditModel
  className?: string
  onOpenAuditEditModal?: () => void
}

const StyledHeader = styled.h4`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const AuditInfo = observer(function AuditInfo(props: AuditInfoProps) {
  const { className, audit, onOpenAuditEditModal } = props
  const [t] = useTranslation()
  const onSaveNote = useCallback(
    (content: string) => {
      auditsController.SetNote(audit.id, content)
    },
    [audit.id]
  )

  const { isReadonly } = audit

  return (
    <div className={className}>
      <StyledHeader>
        {capitalizeFirstLetter(t('audit'))}
        {!isReadonly && (
          <TdsButton
            variant='primary'
            modeVariant='primary'
            onClick={onOpenAuditEditModal}
            size='sm'
            text={capitalizeFirstLetter(t('edit-audit'))}
          />
        )}
      </StyledHeader>
      <TdsBlock modeVariant='secondary'>
        <AuditNote
          className='tds-mode-variant-primary'
          note={audit.note ?? ''}
          onSaveNote={onSaveNote}
          disabled={isReadonly}
        />
      </TdsBlock>
    </div>
  )
})
